import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cacheDom } from '../../utils/QuerySelectors.js'
import { onlyUnique } from '../../utils/helpers.js'
import { setHasOpened, setCountryImage } from '../store/eyewearResultsSlice.js'
import ImageElement from './ImageElement.jsx'

const dom = {}
const qs = {
  swiper: 'data-eyewear-featured-stores',
  hero: 'data-hero-image',
  regionSelectWrap: 'data-region-select-wrap',
  regionSelectWrapInner: 'data-region-select-wrap-inner',
}
const qsAll = {}

const Results = () => {
  const dispatch = useDispatch()
  const { results, hasOpened, regionImage, countryImage } = useSelector((state) => state.eyewearResults)
  cacheDom(dom, qs, qsAll)
  useEffect(() => {
    dispatch(setHasOpened(false))
    
    if(dom.swiper) dom.swiper.classList.toggle('hidden', results.length > 0)
    if(dom.hero) dom.hero.classList.toggle('hidden', results.length > 0)
    if (dom.regionSelectWrap) dom.regionSelectWrap.classList.toggle('lg:items-end', !results.length)
    if(dom.regionSelectWrapInner) dom.regionSelectWrapInner.classList.toggle('lg:max-w-[25rem]', !results.length)
  }, [results])
  
  const countries = results
    .map((result) => result.item.country)
    .filter(onlyUnique)
    .sort()

  const firstImageUrl = () => {
    return regionImage || window.initalBanner
  }

  const updateStates = (e) => {
    setTimeout(() => {
      dispatch(setHasOpened(e.target.closest('details').hasAttribute('open')))
      const details = document.querySelectorAll('[data-eyewear-store-result]')
      const opened = Array.from(details).filter((detail) => detail.hasAttribute('open'))[0]
      dispatch(
        setCountryImage(
          opened
            ? window.countryImages.filter((countryImage) => countryImage.name == opened.dataset.country)[0]?.image
            : null,
        ),
      )
    }, 200)
  }
  return (
    <div className={`lg:grid grid-cols-2 gap-12.5 ${results?.length ? '' : '!hidden'}`}>
      <div className="flex flex-col border-t border-black -mx-2.5 lg:mx-0">
        {countries.map((country, index) => {
          const wholeList = window.storesList
            .filter(store => store.products.includes('eyewear') && store.country == country.toLowerCase() && !!store.city)
            .concat(results.filter(result => result.item.country == country && !!result.item.city))
          return <details
            className={`eyewear-store-result border-b border-black ${hasOpened ? 'hidden' : ''}`}
            key={`eyewear-result-${country}-${index}`}
            data-country={country}
            data-eyewear-store-result
          >
            <summary
              className="text-lg leading-none cursor-pointer py-3.75 flex items-center justify-between px-2.5 lg:px-0"
              onClick={(e) => {
                updateStates(e)
              }}
            >
              <div>{country}</div>

              <div
                className="transition-all ease-in-out duration-200 text-tb-black mr-2.5 w-6 h-6"
                dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-chevron-alt'] }}
              />
            </summary>
            <div>
              {
                wholeList
                .map(result => !!result.item ? result.item.city : result.city)
                .filter(onlyUnique)
                .sort()
                .map((city, index) => {
                  const list = window.storesList
                    .filter(store => store.products.includes('eyewear') && !!store.country && store.country == country.toLowerCase() && !!store.city && store.city.toLowerCase() == city.toLowerCase())
                    .concat(
                      results.filter((result) => !!result.item.country && result.item.country.toLowerCase() == country.toLowerCase() && !!result.item.city && result.item.city.toLowerCase() == city.toLowerCase())
                      .sort((a,b)=> {
                        if(!!a.item) {
                          if (a.item.title < b.item.title)
                            return -1
                          if ( a.item.title > b.item.title)
                            return 1
                        } else {
                          if (a.title < b.title)
                            return -1
                          if ( a.title > b.title)
                            return 1
                        }
                        return 0
                      })
                    )

                  return <details
                    className="eyewear-store-result-city border-t border-black"
                    key={`eyewear-result-${country}-${city}-${index}`}
                  >
                    <summary className="text-lg leading-none cursor-pointer py-3.75 flex items-center justify-between px-2.5 lg:px-0">
                      <div>{city}</div>
                      <span className="plus">+</span>
                      <span className="minus">&ndash;</span>
                    </summary>
                    <div className="pt-2.5 pb-6.25 flex flex-col gap-6.25">
                      {list
                        // .sort((a,b)=> {
                        //   if(!!a.item) {
                        //     if (a.item.title < b.item.title)
                        //       return -1
                        //     if ( a.item.title > b.item.title)
                        //       return 1
                        //   } else {
                        //     if (a.title < b.title)
                        //       return -1
                        //     if ( a.title > b.title)
                        //       return 1
                        //   }
                        //   return 0
                        // })
                        .map((result, index) => (
                          <div
                            className="flex flex-col gap-1.5 text-xs eyewear-store-title"
                            key={`eyewear-result-${country}-${city}-${index}-${!!result.item ? result.item.id : result.id}`}
                          >
                            <div className="eyewear-store-result-title">{result.item?.title || result.title}</div>
                            <div className="eyewear-store-result-address">
                              {
                                result.item ?
                                <a href={`https://maps.google.com/?q=${result.item.addressForSearch}`} target='_blank' title='opens the map in a new window'>
                                  {result.item.addressForSearch}
                                </a> :
                                <a href={`${result.directions}`} target='_blank' title='opens the map in a new window'>
                                  <div dangerouslySetInnerHTML={{ __html: result.addressFull }} />
                                </a>
                              }
                            </div>
                            {!!result.item?.phone || !!result?.phone ? (
                              <a
                                href={`tel:${(result.item?.phone || result.phone).replace(' ', '')}`}
                                className="eyewear-store-result-phone"
                              >
                                {result.item?.phone || result?.phone}
                              </a>
                            ) : (
                              ''
                            )}
                          </div>
                        ))}
                    </div>
                  </details>
                })}
            </div>
          </details>
        })}
      </div>
      <div className="hidden lg:flex flex-col gap-11">
        <ImageElement image={firstImageUrl()} />
        <ImageElement image={countryImage} />
      </div>
    </div>
  )
}

export default Results
